import { render, staticRenderFns } from "./ImpositionVisualizer.vue?vue&type=template&id=7fc5d685&"
import script from "./ImpositionVisualizer.vue?vue&type=script&lang=js&"
export * from "./ImpositionVisualizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports